// Loads the bluezapy brand fonts (Figtree, Bricolage Grotesque) at runtime so the theme works with a
// frontend-only deploy (public/vite), without touching the Rails layout.
const FONT_URL =
  'https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wght@12..96,600;12..96,700&family=Figtree:wght@400;500;600;700&display=swap';

export function loadBrandFonts() {
  if (typeof document === 'undefined') return;
  if (document.querySelector('link[data-brand-fonts]')) return;

  const preconnect = document.createElement('link');
  preconnect.rel = 'preconnect';
  preconnect.href = 'https://fonts.gstatic.com';
  preconnect.crossOrigin = 'anonymous';

  const stylesheet = document.createElement('link');
  stylesheet.rel = 'stylesheet';
  stylesheet.href = FONT_URL;
  stylesheet.dataset.brandFonts = 'true';

  document.head.append(preconnect, stylesheet);
}
